import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const ManyPeopleHand: LucideIcon = forwardRef(({ size = 22, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={(Number(size) * 24) / 22}
      height={size}
      viewBox='0 0 24 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M4.23082 5.8429C5.19287 5.8429 5.97277 5.05913 5.97277 4.09229C5.97277 3.12545 5.19287 2.34167 4.23082 2.34167C3.26877 2.34167 2.48887 3.12545 2.48887 4.09229C2.48887 5.05913 3.26877 5.8429 4.23082 5.8429Z'
        fill={color}
      />
      <path
        d='M8.05143 10.9098C7.99756 8.85685 6.32745 7.21452 4.27572 7.21452C2.22399 7.21452 0.553875 8.85685 0.5 10.9098H8.05143Z'
        fill={color}
      />
      <path
        d='M11.9529 3.50123C12.9149 3.50123 13.6948 2.71745 13.6948 1.75062C13.6948 0.783777 12.9149 0 11.9529 0C10.9908 0 10.2109 0.783777 10.2109 1.75062C10.2109 2.71745 10.9908 3.50123 11.9529 3.50123Z'
        fill={color}
      />
      <path
        d='M19.6794 5.8429C20.6414 5.8429 21.4213 5.05913 21.4213 4.09229C21.4213 3.12545 20.6414 2.34167 19.6794 2.34167C18.7173 2.34167 17.9374 3.12545 17.9374 4.09229C17.9374 5.05913 18.7173 5.8429 19.6794 5.8429Z'
        fill={color}
      />
      <path
        d='M23.5 10.9098C23.4461 8.85685 21.776 7.21452 19.7243 7.21452C17.6726 7.21452 16.0024 8.86136 15.9486 10.9098H23.5Z'
        fill={color}
      />
      <path
        d='M12.0337 6.89869C12.981 6.89869 13.7532 7.63413 13.834 8.56809H15.7735C15.7196 6.51518 14.0495 4.87285 11.9978 4.87285C9.94603 4.87285 8.27591 6.51969 8.22204 8.56809H10.2334C10.3142 7.63413 11.0864 6.89869 12.0337 6.89869Z'
        fill={color}
      />
      <path
        d='M12.0337 7.80107C11.5802 7.80107 11.2076 8.13495 11.1313 8.56809H12.9361C12.8598 8.13495 12.4871 7.80107 12.0337 7.80107Z'
        fill={color}
      />
      <path
        d='M8.63059 15.6608C8.45998 15.6608 8.29387 15.7014 8.13674 15.7781V22H21.3944V15.2547C21.3944 14.9795 21.2732 14.7223 21.0667 14.5464C20.8556 14.3659 20.5818 14.2982 20.3034 14.3478C19.8814 14.4245 19.5627 14.8441 19.5627 15.3224V16.4143H18.5839V14.3253C18.5839 13.847 18.2652 13.4274 17.8432 13.3507C17.5648 13.2966 17.2909 13.3687 17.0799 13.5492C16.8689 13.7252 16.7522 13.9824 16.7522 14.2576V16.4143H15.7735V13.4725C15.7735 12.9943 15.4547 12.5747 15.0327 12.498C14.7543 12.4438 14.4805 12.516 14.2695 12.6965C14.0585 12.8724 13.9417 13.1296 13.9417 13.4048V16.4143H12.963V8.72149C12.963 8.21165 12.55 7.80107 12.0471 7.80107C11.5443 7.80107 11.1313 8.21616 11.1313 8.72149V20.4389H10.1525V16.7933C10.1525 16.1661 9.64523 15.6608 9.02118 15.6608H8.63059Z'
        fill={color}
      />
    </svg>
  )
})

ManyPeopleHand.displayName = 'ManyPeopleHand'
